import { getOrderTicketRedemptionCardRedemptionDetails, getOrderVoucherRedemptionDetails, getTicketTypeById } from '@vista/omnichannel-components-domain';
/**
 * Tickets are sorted in the following order:
 * 1. Redemption Card and Voucher tickets
 *  1.1. Most recently added card/voucher first
 * 2. Loyalty tickets
 * 3. Standard tickets
 *
 * Tickets within each sort category are then sorted by display priority.
 */
export const sortTickets = (tickets) => {
    const sortableTickets = tickets.map(ticket => mapTicketToSortableTicket(ticket));
    const sortedTickets = sortableTickets.sort((a, b) => {
        if (a.sortOrder > b.sortOrder)
            return 1;
        if (a.sortOrder < b.sortOrder)
            return -1;
        if (a.addedAt && b.addedAt) {
            if (a.addedAt > b.addedAt)
                return -1;
            if (a.addedAt < b.addedAt)
                return 1;
        }
        return a.displayPriority - b.displayPriority;
    });
    return sortedTickets.map(s => s.ticket);
};
var TicketSortOrder;
(function (TicketSortOrder) {
    TicketSortOrder[TicketSortOrder["Voucher"] = 1] = "Voucher";
    TicketSortOrder[TicketSortOrder["RedemptionCard"] = 1] = "RedemptionCard";
    TicketSortOrder[TicketSortOrder["Member"] = 2] = "Member";
    TicketSortOrder[TicketSortOrder["Standard"] = 3] = "Standard";
})(TicketSortOrder || (TicketSortOrder = {}));
const mapTicketToSortableTicket = (ticket) => {
    const ticketType = getTicketTypeById(ticket.ticketTypeId);
    return {
        ticket,
        displayPriority: ticketType.displayPriority,
        sortOrder: getSortOrderOfTicket(ticket, ticketType),
        addedAt: getAddedAtDateOfTicket(ticket)
    };
};
const getSortOrderOfTicket = (ticket, ticketType) => {
    if (!!ticket.voucherId)
        return TicketSortOrder.Voucher;
    if (!!ticket.ticketRedemptionCardId)
        return TicketSortOrder.RedemptionCard;
    if (!!ticket.rewardId || ticketType.isRestrictedToMembers)
        return TicketSortOrder.Member;
    return TicketSortOrder.Standard;
};
const getAddedAtDateOfTicket = (ticket) => {
    const { voucherId, ticketRedemptionCardId } = ticket;
    if (!!voucherId)
        return getAddedAtDateOfVoucher(voucherId);
    if (!!ticketRedemptionCardId)
        return getAddedAtDateOfTicketRedemptionCard(ticketRedemptionCardId);
    return undefined;
};
const getAddedAtDateOfVoucher = (voucherId) => {
    const redemptionDetails = getOrderVoucherRedemptionDetails(voucherId);
    return redemptionDetails.addedAt;
};
const getAddedAtDateOfTicketRedemptionCard = (ticketRedemptionCardId) => {
    const redemptionDetails = getOrderTicketRedemptionCardRedemptionDetails(ticketRedemptionCardId);
    return redemptionDetails.addedAt;
};
